export default class CritereValeur {
    constructor(data = {}) {
        this.id = data.id || -1;
        this.idValeur = !data.idValeur && typeof data.idValeur !== 'number' ? null : data.idValeur;
        this.typeRecherche = data.typeRecherche || 0;
        this.valeur1 = data.valeur1;
        this.valeur2 = data.valeur2;
    }
}
